<div class="content">
  <h2 mat-dialog-title>{{ "onPremiseSyncDialog.title" | translate }}</h2>
  <mat-dialog-content>
    <ul>
      <li *ngFor="let task of tasks | keyvalue" class="container">
        <div class="task-row">
          <div class="action">{{task.key | translate}}:</div>
          <div class="status" [ngClass] = "task.value ? 'completed' : 'inprogress'">{{(task.value ? 'onPremiseSyncDialog.completed' : 'onPremiseSyncDialog.progress') | translate}}</div>
          <div class="checkmark"><mat-icon class="done-icon" *ngIf="task.value">check_small</mat-icon></div>
        </div>
      </li>
    </ul>
  </mat-dialog-content>
  <mat-dialog-actions class="dialog-action">
    <evc-nav-button type="primary"  mat-dialog-close>{{ "onPremiseSyncDialog.close" | translate }}</evc-nav-button >
  </mat-dialog-actions>
</div>


